// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mo-0";